import styled from "styled-components";

export const Step = styled.div`
  margin-top: 42px;
  margin-bottom: 68px;
`;

export const Inputs = styled.div`
  & > * + * {
    margin-top: 16px;
  }
`;
